import React from 'react';
import { FederationMembersPage } from '../../components/FederationMembersPage';
const members = [{
  name: 'Захарова Ксенія',
  role: 'Голова комісії атлетів',
  email: 'climbksusa@gmail.com'
}, {
  name: 'Казбекова Євгенія',
  role: 'Заступник Голови комісії атлетів',
  email: 'sunny.kazbekova@gmail.com'
}, {
  name: 'Ткач Ярослав',
  role: 'Член комісії атлетів',
  email: 'tkachyaroslavwork@gmail.com'
}];
export function AthletesCommission() {
  return <FederationMembersPage title="Комісія атлетів" subtitle="Комісія атлетів скельного комітету ФАіСУ" members={members} data-id="element-521" />;
}